"use client";

import {isActivePath} from "@/shared/libs/url-utils";
import Image from "next/image";
import {usePathname, useSearchParams} from "next/navigation";
import staticData from "@/public/data/landing.json";
import MobileBanner from "../../../containers/components/layouts/Banner/components/MobileBanner";

import {useDeviceType} from "@/shared/context/DeviceContext";
import type {WebsiteSettings} from "@/types/services/public/apis/Settings";
import {Dialog, DialogContent} from "@/shared/components/common/Dialog";
import {useState,useEffect} from "react";
import {ListIcon} from "@phosphor-icons/react";
import MobileDrawer from './MobileDrawer';
import { getCookie,setCookie } from "@/shared/libs/utils";

interface MobileHeaderProps {
    profileData: ProfileResult | null;
    settings: WebsiteSettings;
}

export default function MobileHeader({
                                         profileData,
                                         settings,
                                     }: MobileHeaderProps) {
    const searchParams = useSearchParams();
    const utmSource = searchParams.get("utm_source");
    const {activePaths} = staticData.header;
    const path = usePathname();
    const landingPath = activePaths.includes(path);
    const deviceType = useDeviceType();
    const [openDrawer, setOpenDrawer] = useState<boolean>(false)
    const {header_logos} = settings.theme;

    const [adsPopupOpen, setAdsPopupOpen] = useState<boolean>(false);
    const [b2bAdsPopupOpen, setB2bAdsPopupOpen] = useState<boolean>(false);

    useEffect(() => {
        if (!process.env.NEXT_PUBLIC_BASE_URL?.includes("mdsafar")) return;
        if (utmSource === "safarmarket") return;

        const adsCookie = getCookie("ads_popup_shown");
        const b2bCookie = getCookie("b2b_ads_popup_shown");

        // حالت کاربر ساین نشده
        if (!profileData?.is_sign && !adsCookie) {
            setAdsPopupOpen(true);
            setCookie("ads_popup_shown", "true", 1); // 1 روز
        }

        // حالت کاربر ساین شده
        if (profileData?.is_sign && !b2bCookie) {
            setB2bAdsPopupOpen(true);
            setCookie("b2b_ads_popup_shown", "true", 1);
        }
    }, [profileData?.is_sign, utmSource]);

    if (isActivePath(activePaths, usePathname()))
        return (
            <>
                <MobileBanner className="!h-14">
                    <button
                        onClick={() => {
                            setOpenDrawer(true);
                        }}
                        className="text-xl "
                    >
                        <ListIcon size={26}/>
                    </button>
                    {header_logos && (
                        <Image
                            src={header_logos}
                            width={200}
                            height={100}
                            alt="logo"
                            className="w-auto h-12"
                            quality={100}
                        />
                    )}
                </MobileBanner>
                <Dialog open={adsPopupOpen} onOpenChange={() => setAdsPopupOpen(false)}>
                    <DialogContent className="max-sm:w-[95%] rounded-xs sm:max-w-[70rem] bg-background p-0">
                        <Image
                            src="/images/ads-popup1.webp"
                            alt="Advertisement"
                            className="w-full h-auto rounded-xs"
                            width={1000}
                            height={600}
                        />
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={b2bAdsPopupOpen}
                    onOpenChange={() => setB2bAdsPopupOpen(false)}
                >
                    <DialogContent className="max-sm:w-[95%] rounded-xs sm:max-w-[70rem] bg-background p-0">
                        <Image
                            src="/images/b2b-popup.webp"
                            alt="Advertisement"
                            className="w-full h-auto rounded-xs"
                            width={1000}
                            height={600}
                        />
                    </DialogContent>
                </Dialog>
                <MobileDrawer onClose={() => {
                    setOpenDrawer(false);
                }} isOpen={openDrawer}/>
            </>
        );
}
